'use strict';

class AuthenticationService{
        
        constructor($http, $cookies, $rootScope, $timeout,$q,MenuService,ClearService,MessagingService) {
               
                this.$http=$http;
                this.$cookies=$cookies;
                this.$rootScope=$rootScope;
                this.$timeout = $timeout;
                this.ClearService=ClearService;
                this.$q=$q;
                this.MenuService=MenuService;
                this.MessagingService = MessagingService;
        }
        
        static $inject = ['$http', '$cookies', '$rootScope', '$timeout','$q','MenuService', 'ClearService','MessagingService'];

        // Requesting password reset , server will send e-mail to requester
        // ----------------------------------------------
        RequestPswReset (email, callback) {
               
            var response = {};
            this.$http.post('/api/change-password-request/', { email: email })
                .then(function (data) {
                    response = {data: data,success : true};
                    callback(response);
                },
                function (data) {
                    response = {success : false};
                    response.message = 'E-mail not in database!';
                    callback(response);
                }); 
 
        };
        
        // Password reset function
        // ----------------------------------------------
        PswReset (digest, password1, password2, callback) {
               
            var response = {};
            let self=this;
          
            // Check if digest (from email) is valid
            this.$http.post('/api/check-change-password/', { digest: digest })
                .then(function (data) {
                    response = {data: data,success : true};
                    //if we have good digest we got user and continue with reset
                    if (data.user_id) {
                        //POST, šalješ polja password1, password2, digest, user_id
                         self.$http.post('/api/change-password/', { password1: password1, password2:password2,digest:digest,user_id:data.user_id,type:0 })
                         .then(function (data) {
                                //change-password success
                                response = {data: data,success : true};
                                callback(response); 
                            },function (data) {
                                response = {success : false};
                                response.message = 'Password reset failed';
                                callback(response);
                            }); 
                    
                      }//if

                },
                function (data) {
                    response = {success : false};
                    response.message = 'Password reset failed';
                    callback(response);
                }); 
 
        };
         //**********************************************************
	//           GET RELATED DATASET FOR Widget
	//**********************************************************
        ChangePassword(cPass,nPass){
 
                var deferred = this.$q.defer();   
                this.$http({
                        method: 'POST',
                        url: '../api/change-password/',
                        headers: { 'Content-Type': 'application/json' },
                        data: { password1: cPass, password2:nPass,digest:'',user_id:0,type:1}
               
                })
                .then(function (data) {
                    
                    if (data.status === 200) {
                    
                        deferred.resolve({data: data.data,status:data.status});
                   
                    } else {
                      
                        deferred.reject({data: data.data,status:data.status}); 
                       
                    }
                },function (data) {

                        deferred.reject({data: data.data,status:data.status}); 
                   
                });
                
                return deferred.promise;
 
        }
        Login (username, password, callback) {
 
            /* Dummy authentication for testing, uses $timeout to simulate api call
             ----------------------------------------------*/
          /*  $timeout(function(){
                var response = { success: username === 'test' && password === 'test' };
                if(!response.success) {
                    response.message = 'Username or password is incorrect';
                }
                callback(response);
            }, 100);
          */
 
             var response = {};
            /* Use this for real authentication
             ----------------------------------------------*/
            this.$http.post('/api/login/', { username: username, password: password })
                .then(function (data) {
                    response = {data: data,success : true};
                    callback(response);
                },
                function (data) {
                    response = {success : false};
                    response.message = 'Login failed';
                    callback(response);
                });
 
        };
        
        
          Logout (callback) {
 
             var response = {};
             var auth_header = this.$http.defaults.headers.common['Authorization'];
            /* Use this for real authentication
             ----------------------------------------------*/
           this.$http({
                method: 'POST',
                url: '/api/logout/',
                headers: { 'Authorization': auth_header },

               // data: $scope.resource
             
            })
                .then(function (data) {
                    response = {success : true};
                    callback(response);
                },
                function (data) {
                    response = {success : false};
                    response.message = 'Logout failed';
                    callback(response);
                });
 
        };
  
        SetCredentials (user,username, password) {
            
           // var authdata = Base64.encode(username + ':' + password);
            var authdata = "Token " +user.token;
  
            this.$rootScope.globals = {
                currentUser: {
                    userid : user.userid,
                    first_name: user.first_name,
                    last_name : user.last_name,
                    email: user.email,
                    username: user.username,
                    is_superuser:user.is_superuser,
                    last_login:user.last_login,
                    authdata: authdata,
                    lang: user.lang.value,
                    langObj : user.lang,
                    pages:[],
                    pagesLoaded:false,
                    navBars:[],
                    navbarLoaded:false,
                    cMenus:{},
                    organisation:user.organisation,
                    groups:user.groups,
                    uep:user.uep,
                }
                
        
            };
            
              
           // this.$http.defaults.headers.common['Authorization'] = 'Basic ' + authdata; // jshint ignore:line
            this.$http.defaults.headers.common['Authorization'] = authdata; // jshint ignore:line
            this.$cookies.putObject('globals', this.$rootScope.globals);
        };
        UpdateAuthToken(token)
        {
                let authdata = "Token " +token;
                this.$rootScope.globals.currentUser.authdata=authdata;
                this.$http.defaults.headers.common['Authorization'] = authdata;
                this.$cookies.putObject('globals', this.$rootScope.globals);
        }        
       
          SetMenusForApp(app) {
            var deferred = this.$q.defer();
            this.$rootScope.globals.currentUser.navBars = [];
            
            this.MenuService.setSelectedApp(app);
            
            this.MenuService.getMenus($rootScope.globals.currentUser.lang,2,true,app.id).then(function (data) {
                               
                                this.MenuService.navbarItems =  this.MenuService.getNavbarsFromMenus(this.$rootScope.globals.currentUser.lang,2,false,app.id);
                                this.MenuService.generateChildrenNavbarRight();
                               
                                this.$rootScope.globals.currentUser.navbarLoaded=true;
                               
                                return deferred.resolve(true);
            });
         return deferred.promise; 
        };
        
        SetNavbars() { 
           var deferred = this.$q.defer(); 
           this.MenuService.getNavbar(this.$rootScope.globals.currentUser.lang).then(function (data) {
                               this.$rootScope.globals.currentUser.navBars = data;
                                //$scope.navbar=$scope.getLinkNavbar($state.current.name);
                               this.MenuService.generateChildrenNavbarRight();
                               this.$rootScope.globals.currentUser.navbarLoaded=true;
                               //$cookies.put('globals', $rootScope.globals);
                               return deferred.resolve(true);
                               // $scope.getMenusForPage();
            });
           return deferred.promise; 
        }
    
        ClearCredentials () {
            this.$rootScope.globals.currentUser = {lang:'en-GB',InterceptorIsActive : true};
            this.$cookies.remove('globals');
            this.$http.defaults.headers.common.Authorization = 'Token ';
            this.ClearService.Clear();
            this.MessagingService.clearAllMessages();
        };
  
        /*
        static AuthenticationFactory(this.Base64, this.$http, this.$cookies, this.$rootScope, this.$timeout,this.ClearService,this.$q,this.MenuService){
                return new AuthenticationService(this.Base64, this.$http, this.$cookies, this.$rootScope, this.$timeout,this.ClearService,this.$q,this.MenuService);
        }*/
  }

export default AuthenticationService;

class UserService {
        
        constructor($q,$http)
        {
                this.users=[];
                this.groups =[];
                this.count_call=0;
                this.$q =$q;
                this.$http=$http;
                
        }
        
        static $inject = ['$q','$http'];
        
        getUsersGroups (auth_type) {
        
                var deferred = this.$q.defer();                   
                var dataFound=false;   
                if (auth_type=="users") {
                        if (this.users.length>0) {
                                dataFound=true;
                                deferred.resolve({data: this.users, status: 200});
                        }
                }
      
                if (auth_type=="groups") {
                        
                        if (this.groups.length>0) {
                                dataFound=true;
                                deferred.resolve({data: this.groups, status: 200});
                        }
                }
                if (!dataFound)
                {
                        var instance = this;
                        
                        this.$http({
                        method: 'GET',
                        url: '../api/'+auth_type+'/',
                        headers: { 'Content-Type': 'application/json' },
                        })
                        .then(function (data) {

                                if (data.status === 200) {
                      
                                        if (auth_type=="users") {
                       
                                                instance.users = data.data;
                                        }
                      
                                        if (auth_type=="groups") {
                       
                                                instance.groups = data.data;
                                        }
                      
                                        deferred.resolve({data:data.data,status:data.status});
                      
                                } else {
                                        deferred.reject({data:data.data,status:data.status});
                                        }
                        },function (data) {
                    
                                deferred.reject({data:data.data,status:data.status});
                        });
				
                }
        
                return deferred.promise;
 
        };

        getGroupsExtended () {
        
          var deferred = this.$q.defer();                   
        
          this.$http({
                method: 'GET',
                url: '../api/groupsextended/',
                headers: { 'Content-Type': 'application/json' },

               // data: $scope.resource
             
            })
                .then(function (data) {

                    if (data.status === 200) {
                                          
                      deferred.resolve({data:data.data,status:data.status});
                      
                    } else {
                        deferred.reject({data: data, status:data.status});
                    }
                },
                function (data) {
                    
                    //console.log("ERROR!!!-"+status);
                    deferred.reject({data: data, status:data.status});
                });
        
                return deferred.promise;
 
        }



        getUsersExtended () {
        
          var deferred = this.$q.defer();                   
        
          this.$http({
                method: 'GET',
                url: '../api/usersextended/',
                headers: { 'Content-Type': 'application/json' },

               // data: $scope.resource
             
            })
                .then(function (data) {

                    if (data.status === 200) {
                                          
                      deferred.resolve({data:data.data,status:data.status});
                      
                    } else {
                        deferred.reject({data: data, status:data.status});
                    }
                },
                function (data) {
                    
                    //console.log("ERROR!!!-"+status);
                    deferred.reject({data: data, status:data.status});
                });
        
                return deferred.promise;
 
        }

        
       getUserObjectById (userId){
        
       var deferred = this.$q.defer();
       
        if (userId==null)
        {
          userId="";
          
        }
        if (this.users.length==0)
        {
          this.count_call++;
          if (this.count_call<1)
          {
              getUsersGroups('users').then(function(){
            
             var pos = this.users.map(function(e) { return e.id.toString(); }).indexOf(userId.toString());
              if (pos>=0)
              {
                deferred.resolve(this.users[pos]);
              
              } else  deferred.resolve(null);     
            
            });
          }
          
        }
            var pos = this.users.map(function(e) { return e.id.toString(); }).indexOf(userId.toString());
            if (pos>=0)
            {
              deferred.resolve(this.users[pos]);
            } else deferred.resolve(null);     
        
        
               return deferred.promise;
           
    };
    
       getGroupObjectById (groupId){
        
       var deferred = this.$q.defer();
       
        if (groupId==null)
        {
          groupId="";
          
        }
        if (this.groups.length==0)
        {
          this.count_call++;
          if (this.count_call<1)
          {
              service.getUsersGroups('groups').then(function(){
            
             var pos = this.groups.map(function(e) { return e.id.toString(); }).indexOf(groupId.toString());
              if (pos>=0)
              {
                deferred.resolve(this.groups[pos]);
              
              } else  deferred.resolve(null);     
            
            });
          }
          
        }
            var pos = this.groups.map(function(e) { return e.id.toString(); }).indexOf(groupId.toString());
            if (pos>=0)
            {
              deferred.resolve(this.groups[pos]);
            } else deferred.resolve(null);     
        
        
               return deferred.promise;
           
    };
    
    //**********************************************************
	//           SAVE Group
  //**********************************************************      
        SaveGroup (group) {
    
          var http_method="POST";
          var url='../api/save-group/';
          var deferred = this.$q.defer();
          var instance=this;
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data: group

            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                      //Refresh groups
                      instance.groups =data.data.groups;
                      deferred.resolve({data:data.data,status:data.status});
                
                
                    } else {
                      deferred.reject({data:data.data,status:data.status});

                    }
                },
                function (data) {

                    // if error, bind success message to message
                  deferred.reject({data:data.data,status:data.status});

                });
                   return deferred.promise;
        };

 

        //**********************************************************
	//           SAVE User
        //**********************************************************      
        SaveUser (user) {
    
          var http_method="POST";

          var url='../api/save-user/';
             var deferred = this.$q.defer();
             var instance = this;
            this.$http({
                method: http_method,
                url: url,
                headers: { 'Content-Type': 'application/json' },
                data: user

            })
                .then(function (data) {
                    // console.log(data);

                    if (data.status === 200) {
                    
                      instance.users=data.data.users;    
                      deferred.resolve({data:data.data,status:data.status});
                
                
                    } else {
                      deferred.reject({data:data.data,status:data.status});

                    }
                },
                function (error) {

                    // if error, bind success message to message
                  deferred.reject({data:error,status:error.status});

                });
                   return deferred.promise;
        };


}

export {UserService};   
   
class Base64 {
    /* jshint ignore:start */
        constructor()
        {
                this.keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';    
        }
    
  
  
        encode (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
  
            do {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);
  
                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;
  
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
  
                output = output +
                    this.keyStr.charAt(enc1) +
                    this.keyStr.charAt(enc2) +
                    this.keyStr.charAt(enc3) +
                    this.keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            } while (i < input.length);
  
            return output;
        }
  
        decode (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
  
            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            var base64test = /[^A-Za-z0-9\+\/\=]/g;
            if (base64test.exec(input)) {
                window.alert("There were invalid base64 characters in the input text.\n" +
                    "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                    "Expect errors in decoding.");
            }
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  
            do {
                enc1 = this.keyStr.indexOf(input.charAt(i++));
                enc2 = this.keyStr.indexOf(input.charAt(i++));
                enc3 = this.keyStr.indexOf(input.charAt(i++));
                enc4 = this.keyStr.indexOf(input.charAt(i++));
  
                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;
  
                output = output + String.fromCharCode(chr1);
  
                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }
  
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
  
            } while (i < input.length);
  
            return output;
        }
}

//export Base64;

/* jshint ignore:end */
